import { DarkMode } from "@tento-ui/dark-mode";
import { EventCategories, EventDrafts, type EventItemPresentation, ThemesClient } from "@tento-lona";

/**
 * What a storybook page titles and colours its sample events with. The
 * gallery has no client (and no per-user theme store), so the event
 * categories resolve in the default theme (`ThemesClient.Theme.BASE`) and the
 * page's dark mode — without a theme every category chip reads gray — and no
 * editor opens a draft.
 */
export const STORYBOOK_EVENT_PRESENTATION: EventItemPresentation.Scope = {
  categories: new EventCategories({
    theme: () => ThemesClient.Theme.BASE,
    isDark: () => DarkMode.isDarkMode(),
    platform: "other",
  }),
  drafts: new EventDrafts(),
};
